import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import { Col } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import { IMatch } from 'src/share/types/match';
import { BiometricaBinderLists } from './BiometricaBinderList/BiometricaBinderLists';
import usePhotoViewer from 'src/share/components/PhotoViewer/usePhotoViewer';

export interface IBiometricaDetailProps {
  matchInfo: IMatch;
}

const BiometricaDetail = ({ matchInfo }: IBiometricaDetailProps) => {
  const { handleZoomInImage } = usePhotoViewer();
  return (
    <Col md={7}>
      {matchInfo.details && matchInfo.details.suspects && matchInfo.details.suspects.length > 0 && matchInfo.details.suspects.map(suspect =>
        <div key={suspect.id} className="match-info biometrica-detail-info white-background">
          <Row>
            <Col md={12} className={'imageContainer'}>
              <div className="col-xs-12">
                <div className="col-xs-12 header-container">
                  <Label className="subFont">Biometrica</Label>
                  <div className="container-img" onClick={() => handleZoomInImage({ source: suspect.matchFace.url, boundingBoxes: [] })}>
                    <img src={suspect.matchFace.url} style={{ maxHeight: 250 }} />
                    <div className="bounding-box" style={{ position: 'absolute' }} />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} className="stats-info">
              <p><Label>Name:</Label>{suspect.fullName || 'Unknown'}</p>
              <p><Label>Similarity:</Label>{suspect.similarity.toFixed(2) || 'Unknown'}</p>
              <p><Label>Gender:</Label>{suspect.gender || 'Unknown'}</p>
              <p><Label>Nationality:</Label>{suspect.nationality || 'Unknown'}</p>
            </Col>
            <Col md={6} className="stats-info">
              <p><Label>Birthdate:</Label>{suspect.dateOfBirth || 'Unknown'}</p>
              <p><Label>Height:</Label>{suspect.height || 'Unknown'}</p>
              <p><Label>Weight:</Label>{suspect.weight || 'Unknown'}</p>
            </Col>
          </Row>
          {suspect.information && <BiometricaBinderLists information={suspect.information} suspectId={suspect.id} />}
        </div>)}
    </Col>
  )
}

export default React.memo(BiometricaDetail);
